import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  author: string;
  date: string;
  coverUrl: string;
  categorySlug: string;
}

export default function ArticleCard({
  title,
  slug,
  excerpt,
  author,
  date,
  coverUrl,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={coverUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400">{author}</span>
          <span className="text-xs text-foreground-400">{date}</span>
        </div>
      </div>
    </Link>
  );
}